import { createAsyncThunk } from '@reduxjs/toolkit';

import { apiSahClients, apiSahExternalServices } from '~constants/api';

import { get, post, put, remove, upload } from '~libs/genericAction';
import { createThunks, Params } from '~libs/reduxUtils';

export const typePrefix = 'sah-external-services';

type FileUploadParams = {
  file: File;
  setProgress?: (value: number) => void;
};

const config = [
  { actionType: 'getGrouped', apiPath: `${apiSahExternalServices}`, method: get },
  {
    actionType: 'getAll',
    apiPath: (params: Params) => `${apiSahClients}/${params.client_id}/external/services`,
    method: get,
  },
  { actionType: 'create', apiPath: `${apiSahExternalServices}`, method: post },
  {
    actionType: 'update',
    apiPath: (params: Params) => `${apiSahExternalServices}/${params.id}`,
    method: put,
  },
  {
    actionType: 'deleteOne',
    apiPath: (params: Params) => `${apiSahExternalServices}/${params.id}`,
    method: remove,
  },
];

export const uploadFile = createAsyncThunk(
  // Changed type prefix to avoid error conflict
  `sah-external-services-upload/upload`,
  async ({ file, setProgress }: FileUploadParams, { rejectWithValue }) => {
    try {
      return await upload(
        `${apiSahExternalServices}/upload`,
        file,
        (progress) => {
          if (typeof progress === 'number') {
            setProgress?.(progress);
          }
        },
        undefined,
        undefined,
        true,
      );
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);

export const { getGrouped, getAll, create, deleteOne, update } = createThunks(typePrefix, config);
